<script>
export default {
    name: 'PromotionCollection_CampaginCard',
    props: {
        card: Object,
        label: Object,
    }
}
</script>

<template>
    <article class="nti-promotion__campaign-card">
        <a :href="card.link">
            <div class="nti-promotion__campaign-card__image" :style="card.imageUrl ? { background: `linear-gradient(0deg, rgba(38, 48, 56, 0.85), rgba(38, 48, 56, 0.85)), no-repeat center url(${card.imageUrl})` } : null"></div>
            <div class="nti-promotion__campaign-card__content-container">
                <h3 class="nti-promotion__campaign-card__title">{{ card.title }}</h3>
                <div class="nti-promotion__campaign-card__line"></div>
                <p class="nti-promotion__campaign-card__text">{{ card.messageShort }}</p>
            </div>
        </a>
    </article>
</template>